import { Box, styled } from '@mui/material';

interface StyledBoxProps {
  density: 'panel' | 'page';
}

const StyledBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'density',
})<StyledBoxProps>(({ density }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: density === 'page' ? 16 : 10,

  '& .compliancePendingItems': {
    display: density === 'page' ? 'grid' : 'flex',
    ...(density === 'page'
      ? { gridTemplateColumns: '1fr 1fr', gap: 16 }
      : { flexDirection: 'column', gap: 10 }),
  },
}));

export default StyledBox;
